export default __webpack_public_path__ + "static/media/banner154ham.f6b61f01.png";